import { render, staticRenderFns } from "./AgentItem.vue?vue&type=template&id=5ca781b0&scoped=true&"
import script from "./AgentItem.vue?vue&type=script&lang=js&"
export * from "./AgentItem.vue?vue&type=script&lang=js&"
import style0 from "./AgentItem.vue?vue&type=style&index=0&id=5ca781b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca781b0",
  null
  
)

export default component.exports